import { createSlice } from '@reduxjs/toolkit';
import qs from 'qs';
import * as R from 'ramda';
import http from 'utils/http';
import { createSnack } from 'snackbar/snackbarSlice';

const initialState = {
  error: '',
  originatorLocationProductBalances: {},
  pending: false,
};

const reducers = {
  fetchOriginatorLocationProductBalancesError(state, { payload }) {
    return R.assoc('error', payload, state);
  },
  fetchOriginatorLocationProductBalancesPending(state, { payload }) {
    return R.assoc('pending', payload, state);
  },
  fetchOriginatorLocationProductBalancesSuccess(state, { payload }) {
    return R.assoc('originatorLocationProductBalances', payload, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'originatorLocationProductBalances',
  reducers,
});

const {
  fetchOriginatorLocationProductBalancesPending,
  fetchOriginatorLocationProductBalancesSuccess,
  fetchOriginatorLocationProductBalancesError,
} = actions;

// Actions
let fetchController;
export function fetchOriginatorLocationProductBalances(params = {} /* , cancelToken */) {
  const formattedParams = qs.stringify(params, {
    allowDots: true,
    encode: false,
  });

  if (fetchController) fetchController.abort();
  fetchController = new AbortController();
  const { signal } = fetchController;

  return dispatch => {
    dispatch(fetchOriginatorLocationProductBalancesPending(true));

    return http
      .get(`/product-transfer-orders/get-originator-location-product-balances?${formattedParams}`, {
        signal,
      })
      .then(({ data }) => {
        dispatch(fetchOriginatorLocationProductBalancesError(''));
        dispatch(fetchOriginatorLocationProductBalancesSuccess(data));
        dispatch(fetchOriginatorLocationProductBalancesPending(false));
        return data;
      })
      .catch(error => {
        if (error?.response?.data?.title) {
          dispatch(
            createSnack({
              message: error.response.data.title,
              options: { variant: 'error' },
            })
          );
        }
        return error;
      });
  };
}

export default reducer;
